import { ReactNode } from "react";
import { NewTransferStatusType } from "manifest-components/src/classes/transferInstruction";

import ProgressCircle from "../ProgressCircle";
import IconMoney from "../../pages/TransferStatus/icons/IconMoney";
import IconChecked from "../../pages/TransferStatus/icons/IconChecked";
import IconIRAPending from "../../pages/TransferStatus/icons/IconIRAPending";
import IconArrow from "../../pages/TransferStatus/icons/IconArrow";
import IconSearch from "../../pages/TransferStatus/icons/IconSearch";
import IconCaution from "../../pages/TransferStatus/icons/IconCaution";

export const getTransferStatusProgress = (transferStatus: NewTransferStatusType): ReactNode => {
  switch (transferStatus) {
    case NewTransferStatusType.CANCELLED:
      return (
        <ProgressCircle color="disabled" icon={<IconCaution name="icon-caution" />} progress={0} name="cancelled" />
      );
    case NewTransferStatusType.CHECK_SENT_TO_DESTINATION:
      return <ProgressCircle color="default" icon={<IconMoney name="icon-money" />} progress={25} name="check-sent" />;
    case NewTransferStatusType.COMPLETE:
      return (
        <ProgressCircle color="default" icon={<IconChecked name="icon-checked" />} progress={100} name="completed" />
      );
    case NewTransferStatusType.WAIT_FOR_IRA_OPENING:
    case NewTransferStatusType.PENDING_DESTINATION:
    case NewTransferStatusType.PENDING_ROTH_DESTINATION:
    case NewTransferStatusType.PENDING_TRAD_DESTINATION:
      return (
        <ProgressCircle
          color="default"
          icon={<IconIRAPending name="icon-ira-pending" />}
          progress={25}
          name="ira-pending"
        />
      );
    case NewTransferStatusType.INITIATED_AT_SOURCE:
      return <ProgressCircle color="default" icon={<IconArrow name="icon-arrow" />} progress={25} name="initated" />;
    case NewTransferStatusType.ADDITIONAL_INFORMATION_NEEDED:
    case NewTransferStatusType.SCHEDULE_PHONE_CALL:
    case NewTransferStatusType.IRA_OPENING_ERROR:
      return (
        <ProgressCircle
          color="disabled"
          icon={<IconCaution name="icon-caution" />}
          progress={50}
          name="user-input-needed"
        />
      );
    default:
      return (
        // By default processing
        <ProgressCircle color="default" icon={<IconSearch name="icon-search" />} progress={25} name="processing" />
      );
  }
};

export const getTransferStatusHeading = (transferStatus: NewTransferStatusType): string => {
  switch (transferStatus) {
    case NewTransferStatusType.CANCELLED:
      return "Transfer cancelled";
    case NewTransferStatusType.CHECK_SENT_TO_DESTINATION:
      return "Funds on the way";
    case NewTransferStatusType.COMPLETE:
      return "Transfer complete";
    case NewTransferStatusType.INITIATED_AT_SOURCE:
      return "Transfer initiated";
    case NewTransferStatusType.ADDITIONAL_INFORMATION_NEEDED:
    case NewTransferStatusType.SCHEDULE_PHONE_CALL:
    case NewTransferStatusType.IRA_OPENING_ERROR:
      return "Additional information needed";
    default:
      return "Processing transfer details";
  }
};
